<template>
	<div>
		<NavBar/>
		<div class="header-project" :style="{ 'backgroundImage': 'url('+banner+')' }">
			<div class="header-name bg-gold-gradient">
				<h1 class=" text-white px-5 py-3 text-uppercase">¡Hola {{user.name}}!</h1>
			</div>
		</div>
		<b-container fluid class="mb-5">
			<b-row no-gutters>
				<b-col cols="12" lg="9">
					<h3 class="mt-4">
						<small v-if="apartments.length > 1">Selecciona tu departamento</small>
					</h3>
					<multiselect v-if="apartments.length > 1" :allow-empty="false" class="multiselect-sm mb-4" v-model="selectedApartment" :options="apartments" :close-on-select="true" placeholder="Departmento" track-by="asset_id" :show-labels="false">
						<template slot="noOptions">No hay departamentos disponibles.</template>
						<template slot="singleLabel" slot-scope="props">{{props.option.asset_type.split("_").join(" ")}} {{props.option.number}} <small>{{props.option.project_name}}</small></template>
						<template slot="option" slot-scope="props">{{props.option.asset_type.split("_").join(" ")}} {{props.option.number}} <small>{{props.option.project_name}}</small></template>
					</multiselect>
				</b-col>
				<b-col cols="12" lg="3">
				</b-col>
			</b-row>
			<b-row no-gutters>
				<b-col cols="12" lg="9" class="mb-5">	
					<b-card>
						<apartments :asset="selectedApartment" :tab_index="tab_index" />
					</b-card>
				</b-col>
				<b-col cols="12" lg="3">
					<notices />
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>
<script>
import notices from "./views/notices/Notices";
import apartments from "./views/apartments/Apartments";
import NavBar from './components/NavBar.vue';

export default {
	name: "private",
	computed: {},
	data() {
		return {
			banner: require("@/assets/images/customer/"+this.$store.state.customer+"/banner.jpg"),
			user: this.$auth.user(),
			asset_id: null,
			apartments: [],
			tab_index: 0,
			selectedApartment: null
		}
	},
	mounted() {
		this.$store.commit('setCards');
		this.setApartments();
        this.$store.commit('setCustomerData');
		if(this.$route.query.card_response)
			if(this.$route.query.card_response == "true"){
				this.$swal('Éxito!', 'Tarjeta Agregada con éxito', 'success')
			}else{
				this.$swal('Parace que hubo un error agregando tu tarjeta!', '', 'info')
			}
	},
	components:{ notices, apartments, NavBar },
	methods: {
		setApartments(){
			this.axios.get("assets/").then(result => {
				if(typeof result.data.length != undefined){
					this.apartments = result.data.assets
					this.$store.commit('setApartments', result.data.assets);
					this.selectedApartment = this.apartments[0];
				}
			}).catch(error => {
				console.log(error)
			});
		}
	}
};
</script>
<style scoped>
</style> 